import React from 'react';
import PropTypes from 'prop-types';

import Radio from './Radio';
import Range from './Range';
import Select from './Select';

class renderField extends React.PureComponent {
  render() {
    const {
      input, label, type, meta: { touched, error }, params, centered, placeholder, classes, inputUnit, complicated, plusHandler, minusHandler, setRef, inputMode,
    } = this.props;

    let inputField = <input ref={setRef} {...input} type={type} placeholder={placeholder} className={classes} inputMode={inputMode} />;

    switch (type) {
      case 'select':
        inputField = <Select {...input} {...params} />;
        break;
      case 'radiogroup':
        inputField = <Radio {...input} {...params} />;
        break;
      case 'inputrange':
        inputField = <Range setRef={setRef} {...input} {...params} />;
        break;
      default:
        break;
    }

    if (centered) {
      return (
        <div className="form-register_question justifycentre">
          {label ? <label className="justifycentre">{label}</label> : null}
          { inputField }
          {touched && error && <label className="error">{error}</label>}
        </div>
      );
    }

    if (complicated) {
      return (
        <div className="form-register_question justifycentre">
          {label ? <label className="justifycentre">{label}</label> : null}
          <div className="complicated-input-wrap">
            <button className={`${params.classes} complicated-icon minus`} onClick={minusHandler} />
            { inputField }
            <button className={`${params.classes} complicated-icon plus`} onClick={plusHandler} />
          </div>
          {touched && error && <label className="error">{error}</label>}
        </div>
      );
    }

    return (
      <div className="form-register_field">
        {label ? <label>{label}</label> : null}
        <div className="form-register_input">
          { inputField }
          { inputUnit && <span className="input-unit-text">{inputUnit}</span> }
          {touched && error && <label className="error">{error}</label>}
        </div>
      </div>
    );
  }
}

renderField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  centered: PropTypes.bool,
  type: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
  params: PropTypes.object,
  placeholder: PropTypes.string,
  inputUnit: PropTypes.string,
  complicated: PropTypes.bool,
  plusHandler: PropTypes.func,
  minusHandler: PropTypes.func,
};

renderField.defaultProps = {
  params: {},
  label: null,
  centered: false,
  placeholder: null,
  inputUnit: null,
  complicated: false,
  plusHandler: () => {},
  minusHandler: () => {},
};

export default renderField;



// WEBPACK FOOTER //
// ./src/Components/Inputs/index.jsx